import React, { useEffect, useState } from "react";
import { Box, styled, Tab, Tabs } from "@material-ui/core";
import AdminUploadEpisodes from "./adminUploadEpisodes";
import AdminEpisodeVideos from "./adminEpisodeVideos";
import AdminCourses from "./adminCourses";
import AdminAssignAllowedCourses from "./adminAssignAllowedCourses";
import adminService from "../../Services/adminService";

function TabPanel({ children, value, index }) {
  return (
    <div className="width100 ml-100" role="tabpanel" hidden={value !== index}>
      {value === index && <Box style={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const StyledTabs = styled((props) => <Tabs {...props} TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }} />)({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent"
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%"
  }
});

const StyledTab = styled((props) => <Tab {...props} />)(() => ({
  color: "black",
  "&.Mui-selected": {
    color: "#fff",
    backgroundColor: "#e56126",
    borderRadius: "10px"
  }
}));

export default function AdminVideosContainer() {
  const [value, setValue] = useState(0);
  const [videoDetails, setVideoDetails] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [courses, setCourses] = useState([]);
  const [courseTitle, setCourseTitle] = useState("");

  useEffect(() => {
    async function getCourses() {
      const res = await adminService.getCourses();
      if (res.success) setCourses(res.courses);
    }
    getCourses();
  }, []);

  const handleChange = (event, newValue) => {
    setEditMode(false);
    setVideoDetails({});
    setCourseTitle("");
    setValue(newValue);
  };

  return (
    <div className="mt-100 width100">
      <Box
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "space-between",
          height: "100vh",
          marginBottom: "50px",
          borderRadius: "10px",
          boxShadow: "0 0px 10px 0 rgb(16 36 94 / 20%)"
        }}
      >
        <StyledTabs orientation="vertical" variant="scrollable" value={value} onChange={handleChange} style={{ width: "25vw" }}>
          <StyledTab label="העלה/ערוך פרק" />
          <StyledTab label="פרקים" />
          <StyledTab label="קורסים" />
          <StyledTab label="הקצה מותר לצפות" />
        </StyledTabs>
        <TabPanel value={value} index={0}>
          <AdminUploadEpisodes courses={courses} editMode={editMode} videoDetails={videoDetails} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AdminEpisodeVideos
            courses={courses}
            editMode={editMode}
            setEditMode={setEditMode}
            setVideoDetails={setVideoDetails}
            setValue={setValue}
            courseTitle={courseTitle}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AdminCourses
            setEditMode={setEditMode}
            editMode={editMode}
            setCourseTitle={setCourseTitle}
            setValue={setValue}
            courses={courses}
            setCourses={setCourses}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <AdminAssignAllowedCourses courses={courses} />
        </TabPanel>
      </Box>
    </div>
  );
}
